<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit01">
<a id="page03"></a>
<h2 class="titlePageTitle">L<span class="titlePageCaps2">AST</span> R<span class="titlePageCaps2">ITUALS</span></h2>
<p class="titlePageText"><em class="italic">An Icelandic Novel of Secret Symbols,<br/> Medieval Witchcraft, and Modern Murder</em></p>
<p class="titlePageAuthor">Y<span class="titlePageCaps1">RSA</span> S<span class="titlePageCaps1">IGURDARDÓTTIR</span></p>
<p class="titlePageAuthor1">TRANSLATED FROM THE ICELANDIC BY BERNARD SCUDDER</p>
<p class="titlePageLogo"><img alt="image" src="logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5510bca4